"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_DamageReflectEventHandlerScript = void 0;
const Damage_1 = require("../../core/Damage");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_DamageReflectEventHandlerScript = class Effect_DamageReflectEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Damaged) {
            return;
        }
        const reflectAmount = Math.round(event.args.damage.amount * handler.args.scriptArgs.percent);
        container.applyExactDamage({
            sequence,
            attackerId: event.subject,
            targetId: event.args.damagedBy,
            damage: new Damage_1.Damage(handler.args.scriptArgs.damageTypeOverride || event.args.damage.type, reflectAmount)
        });
    }
};
Effect_DamageReflectEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_DamageReflect")
], Effect_DamageReflectEventHandlerScript);
exports.Effect_DamageReflectEventHandlerScript = Effect_DamageReflectEventHandlerScript;
